import { Link, usePage } from "@inertiajs/react"
import { Fragment } from "react"

import { InlineLeagueSwitcher } from "@/components/inline-league-switcher"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import type { BreadcrumbItem as BreadcrumbItemType } from "@/types"

export function Breadcrumbs({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbItemType[]
}) {
  const { leagues } = usePage().props
  const hasMultipleLeagues = leagues.length > 1

  if (breadcrumbs.length === 0) return null

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1
          return (
            <Fragment key={index}>
              <BreadcrumbItem>
                {item.leagueSwitcher && hasMultipleLeagues ? (
                  <InlineLeagueSwitcher currentLeagueName={item.title} />
                ) : isLast ? (
                  <BreadcrumbPage>{item.title}</BreadcrumbPage>
                ) : item.href || item.leagueSwitcher ? (
                  <BreadcrumbLink asChild>
                    <Link href={item.href}>{item.title}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{item.title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
